<template src="./pipe.html"></template>
<script>
export default {
    name: 'pipe',
    props: ['observations', 'isReport'],
    data() {
        return {
            convertedNodes: null,
            sessionID: null
        };
    },
	computed: {
        pipeNodes() {
            return this.$store.state.ObservationModule.PipeNodes;
        }
	},
    methods: {
        convertPipeNodeForDisplay() {
            this.$store.dispatch('ObservationModule/getPipeNodes', this.sessionID)
                .then(() => {
                    let nodes = DMUtils.copy(this.pipeNodes);
                    let converted = [];
                    nodes.forEach((node) => {
                        if (node.Observations.length === 0) {
                            let noFault = {};
                            noFault.FileName = 'Fault.svg';
                            converted.push(noFault);
                        }
                        node.Observations.forEach((obs) => {
                            converted.push(obs);
                        });
                    });
        
                    this.convertedNodes = converted;
                })
        },
		getPipeNodeImage(node) {
            let cssClasses = 'pipe-image ';
            if (node.FileName === 'Fault.svg' || node.Severity === 0) {
                cssClasses += 'pipe-fault';
            } else {
                cssClasses += 'pipe-fault-' + node.Severity;
            }

            return cssClasses;
        },
        getReportPipeNodeImage(node) {
            let cssClasses = 'pipe-image-report ';
            if (node.FileName === 'Fault.svg' || node.Severity === 0) {
                cssClasses += 'pipe-fault';
            } else {
                let observation = this.observations.find((obs) => obs.ObservationID === node.ObservationID);
                let structWeight = observation.Fields.find((fld) => fld.LabelText === 'Structural Weight');
                let maintWeight = observation.Fields.find((fld) => fld.LabelText === 'Maintenance Weight');
                //TODO: check if node is maintenance or structural
                if (structWeight && parseInt(structWeight.Value) > 0) {
                    cssClasses += 'pipe-fault-struct-' + node.Severity;
                }

                if (maintWeight && parseInt(maintWeight.Value) > 0) {
                    cssClasses += 'pipe-fault-maint-' + node.Severity;
                }
            }

            return cssClasses;
        },
        getReportTextForNode(node) {
            let observation = this.observations.find((obs) => obs.ObservationID === node.ObservationID);

            if (!observation) {
                return;
            }

            let textForNode = "";
            
            if (node.Distance !== '' && node.Distance !== null) {
                textForNode += `(${node.Distance}) `;
            }
            if (node.FaultCode) {
                textForNode += `${node.FaultCode} `;
            }
            if (node.FaultName) {
                textForNode += `- ${node.FaultName} `;
            }
            if (node.PictureNumber) {
                textForNode += `Photo Num: ${node.PictureNumber} `;
            }       
            if (node.VideoPosition !== "" && node.VideoPosition !== null) {
                textForNode += `<strong>Mpeg Pos: </strong> ${node.VideoPosition} `;
            }
            observation.Fields.forEach((field) => {
                if (field.Value) {
                    if (field.Name === 'Percent'
                        || field.Name === 'PipeID'
                        || field.Name === 'PipeNumber'
                        || field.Name === 'Size'
                        || field.Name === 'Continuous'
                        || field.Name === 'Remarks'
                        || field.Name.includes('Dim')
                    ) {
                        textForNode += `<strong>${field.LabelText}:</strong> ${field.Value} `
                    }

                    if (field.Name === 'AtFrom') {
                        textForNode += `<strong> Position From:</strong> ${field.Value} `
                    }

                    if (field.Name === 'To') {
                        textForNode += `<strong> To:</strong> ${field.Value} `
                    }

                    if (field.Name === 'Joint' || field.Name === 'Step') {
                        textForNode += `<strong>${field.LabelText}</strong> `
                    }
                }
            })

            observation.Images.forEach((image, index) => {
                textForNode += `
                    <p class="dm-margin-0">
                        <a href="${image.ImageUrl}" target="_blank" class="dm-color-white dm-pointer">Photo ${index + 1}</a>
                    </p>`;
            });

            return textForNode;
        },
		getTextForNode(node) {
            return `(${node.Distance}) - ${node.FaultCode}`;
        },
		jumpToSpotInVideoByNode(node) {
            let timestamp = node.VideoPosition;
            document.getElementById('observationVideo').currentTime = timestamp;
			this.$store.commit('ObservationModule/setSelectedPipeNode', node);
        },
    },
    created() {
        this.sessionID = this.$route.query.id;
        this.convertPipeNodeForDisplay()
    }
};
</script>
